import { Badge } from "./domain";

export const BADGES: Badge[] = [
  {
    key: "phone",
    label: "Phone Verification",
    points: "80",
    isActive: true,
  },
  {
    key: "github",
    label: "GitHub Account",
    points: "10-20",
    isActive: true,
  },
  {
    key: "twitter",
    label: "Twitter Activity",
    isActive: false,
  },
  {
    key: "on-chain",
    label: "On-chain Activity",
    isActive: false,
  },
  {
    key: "social-vouching",
    label: "Social vouching 3/3",
    isActive: false,
  },
];

export const CIRCUIT_WASM_PATH = "/circuit.wasm";
export const CIRCUIT_ZKEY_PATH = "/circuit_final.zkey";

export const CIRCUIT_BJJ_WASM_PATH = "/bjj/circuit.wasm";
export const CIRCUIT_BJJ_ZKEY_PATH = "/bjj/circuit_final.zkey";

export const CREDENTIAL_SUBJECT_PATH =
  "https://www.w3.org/2018/credentials#credentialSubject";
export const SCORE_PATH =
  "https://raw.githubusercontent.com/demonsh/schema//main/jsonld/presentation.md#score";

export const GITHUB_OAUTH_URL = "https://github.com/login/oauth/authorize";

export const GITHUB_TOKEN_SEARCH_PARAM = "code";
